import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { ROLES } from 'config/constants'
import {
  Typography,
  Box,
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Tooltip
} from '@material-ui/core'
import clsx from 'clsx'
import { useStyles } from './ExpandedRowBankTransfer.style'
import { TransferActionMenu } from './TransferActionMenu'
import { round } from 'views/utils/functions'

export const ExpandedRowBankTransfer = ({ transferData }) => {
  const classes = useStyles()
  const {
    Id,
    Name,
    Email,
    BankAccountAlias,
    BankAccountIdentifier,
    BankName,
    Commission,
    Vat
  } = transferData
  const [commission, setCommission] = useState(Commission)
  const [vat, setVat] = useState(Vat)
  const { user } = useSelector((state) => state.login)
  const rolesArray = user?.roles?.split(',') || []
  const isAdmin = rolesArray?.includes(ROLES.ADMIN)
  const changeCommissions = (com, iva) => {
    setCommission(com)
    setVat(iva)
  }

  return (
    <Box sx={{ margin: 1 }}>
      <Typography variant='h5' className={classes.title} component='div'>
        Datos de la Cuenta
      </Typography>
      <Table size='small' aria-label='purchases'>
        <TableHead>
          <TableRow>
            <TableCell className={classes.cellHead}>
              Banco / Billetera
            </TableCell>
            <TableCell className={classes.cellHead}>CBU / CVU</TableCell>
            <TableCell className={classes.cellHead}>Alias</TableCell>
            <TableCell className={classes.cellHead}>Nombre</TableCell>
            <TableCell className={classes.cellHead}>Email</TableCell>
            {isAdmin && (
              <TableCell className={classes.cellHead}>Comisión</TableCell>
            )}
            {isAdmin && (
              <TableCell className={classes.cellHead}>Acciones</TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow className={classes.bodyStyle}>
            <TableCell className={classes.cellRow}>{BankName}</TableCell>
            <Tooltip title={BankAccountIdentifier} arrow>
              <TableCell className={classes.cellRow}>
                {BankAccountIdentifier}
              </TableCell>
            </Tooltip>
            <Tooltip title={BankAccountAlias} arrow>
              <TableCell className={classes.cellRow}>
                {BankAccountAlias}
              </TableCell>
            </Tooltip>
            <TableCell className={classes.cellRow}>{Name}</TableCell>
            <TableCell className={classes.cellRow}>{Email}</TableCell>
            {isAdmin && (
              <TableCell
                className={clsx({
                  [classes.cellRow]: true,
                  [classes.noCommissions]: commission == null
                })}>
                {commission != null
                  ? `${round(commission * 100)}% - IVA: ${round(vat * 100)}%`
                  : 'Sin configurar'}
              </TableCell>
            )}
            {isAdmin && (
              <TableCell className={classes.cellRow}>
                <TransferActionMenu
                  accountId={Id}
                  commission={commission}
                  vat={vat}
                  changeCommissions={changeCommissions}
                />
              </TableCell>
            )}
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  )
}

export default ExpandedRowBankTransfer
